export default class UserProperties {
  constructor(public user_id: number, public writer_grade_id: number) {}
}
